import { render, staticRenderFns } from "./TutorDisconnectedComponent.vue?vue&type=template&id=73920807&"
import script from "./TutorDisconnectedComponent.vue?vue&type=script&lang=js&"
export * from "./TutorDisconnectedComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports